export default __webpack_public_path__ + "static/media/upEllipse.214b0b1f.png";